import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import useSWR from "swr";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import "./Categories.css";

const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const Categories = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [openElement, setOpenElement] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  // get Category Data
  const {
    data: categoryData,
    error,
    mutate,
  } = useSWR(
    `store/settings/categories?page=${pageIndex}&limit=${limit}`,
    fetcher
  );

  // console.log(error);
  // react hook form
  const { register, handleSubmit, reset } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  // ADD BUTTON handleToggle
  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };

  //  POST Category
  const onSubmit = (data) => {
    setButtonLoading(true);
    API.post("store/settings/categories", data).then((res) => {
      console.log(res);

      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(1, "new Category Added");
        setButtonLoading(false);
        reset();

        mutate();
      } else {
        swal({
          title: "Opps !",
          text: `${res.data.message}`,
          icon: "warning",
          button: "Ok",
        });
        reset();
        mutate();
        setButtonLoading(false);
      }
    });
  };

  //  DELETE CATEGORY

  const deleteButtonHandler = (Id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.delete("store/settings/categories", {
          headers: {
            cat_id: Id,
          },
        }).then((res) => {
          if (res) {
            PostStoreLog(3, "one Category delete");
            mutate();
          }
        });
        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  // Update Section
  const [getId, setGetId] = useState(null);

  //   Update Category

  const onSubmitUpdate = (data) => {
    if (!data.categoryen) {
      data.categoryen = categoryById.categoryen;
    }

    if (!data.categorybn) {
      data.categorybn = categoryById.categorybn;
    }

    API.put("store/settings/categories", data, {
      headers: {
        cat_id: getId,
      },
    }).then((res) => {
      console.log(res);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "Category update");
        reset1();
        window.$("#edit_category").modal("hide");
        mutate();
        window.location.reload();
        mutate1();
      } else {
        swal({
          title: "Opps !",
          text: `${res.data.message}`,
          icon: "warning",
          button: "Ok",
        });
        reset1();
        mutate();
        mutate1();
      }
    });
  };

  const handleUpdate = (updateId) => {
    setGetId(updateId);
  };

  // get Category Data By ID
  const { data: categoryById, mutate: mutate1 } = useSWR(
    getId ? `store/settings/category/${getId}` : null,
    fetcher
  );
  // { refreshInterval: 1000 }
  console.log(categoryById);
  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/settings/categories?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };

  let counter = 1;

  const handleCheckUpdate = (status, cat_id) => {
    console.log(status, cat_id);
    API.put("store/settings/categories/status", { status, cat_id }).then(
      (res) => {
        console.log(res);
        if (!res.data.error) {
          swal({
            title: "Thank You !",
            text: "Successfully update",
            icon: "success",
            button: "Ok",
          });
          PostStoreLog(2, "Category status update");
          reset1();
          window.$("#edit_category").modal("hide");
          mutate();
          window.location.reload();
          mutate1();
        } else {
          swal({
            title: "Opps !",
            text: `${res.data.message}`,
            icon: "warning",
            button: "Ok",
          });
          reset1();
          mutate();
          mutate1();
        }
      }
    );
  };

  return (
    <>
      <Helmet>
        <title>Categories - BBA STORE</title>
        <meta name="description" content="Categories - BBA STORE" />
      </Helmet>

      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            <h3 className="text-start text-dark">Manage Categories</h3>
            <button
              onClick={handleToggle}
              type="button"
              className="btn  px-3 btn-color_store"
            >
              <i className="fa fa-plus"></i>
              <span> Add Category</span>
            </button>
          </div>

          {/* Toogle Element */}
          <div
            className={openElement ? "category_store show" : "category_store"}
          >
            <div className="mx-auto text-center">
              <div className="add_category">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="container px-4">
                    <div className="row gx-5">
                      <div className="col-sm-6">
                        <div className="p-3 ">
                          {" "}
                          <input
                            {...register("categoryen")}
                            placeholder="Enter English Name *"
                            type="text"
                            className="p-2  input_field_category_store"
                          />{" "}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="p-3 ">
                          <input
                            {...register("categorybn")}
                            placeholder="Enter Bangla Name"
                            type="text"
                            className="p-2  input_field_category_store"
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <button
                    type="submit"
                    className="mt-3 px-3 btn btn-color_store"
                  >
                    <i className="fa fa-save"></i>
                    <span> Save</span>

                    {buttonLoading ? (
                      <div
                        style={{ width: "20px", height: "20px" }}
                        class="spinner-border ms-2  text-light"
                        role="status"
                      >
                        <span style={{}} class="visually-hidden ">
                          Loading...
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
          {/* Toogle Element */}

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div_store">
              <div className="col-12 col-md-6 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <input
                  className="p-2 input-field w-100"
                  type="text"
                  onChange={(e) => handleSearch(e)}
                  name="Search"
                  placeholder="Search Categories"
                />
              </div>
            </div>

            {!categoryData ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive search-div_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="2">English Name</th>
                      <th colSpan="2">Bangla Name</th>
                      <th colSpan="2">Status</th>

                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryData.map((item) => (
                      <tr key={counter}>
                        <th>{counter++}</th>
                        <td colSpan="2">{item.categoryen}</td>
                        <td colSpan="2">{item.categorybn}</td>

                        <td colSpan="2" className="text-center">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              defaultChecked={item.status}
                              onChange={(e) =>
                                handleCheckUpdate(
                                  e.target.checked == true ? 1 : 0,
                                  item.cat_id
                                )
                              }
                            />
                          </div>
                        </td>

                        <td className="text-center">
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            type="button"
                            className="btn btn-outline-color_store px-3 me-2"
                            data-toggle="modal"
                            data-target="#edit_category"
                            onClick={() => {
                              handleUpdate(item.cat_id);
                            }}
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            onClick={() => {
                              deleteButtonHandler(item.cat_id);
                            }}
                            data-bs-toggle="tooltip"
                            title="Delete"
                            type="button"
                            className="btn btn-danger px-3"
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {categoryData && categoryData.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Edit Category Modal */}
      <div id="edit_category" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Category</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                <div className="container px-4">
                  <div className="row gx-5">
                    <div className="col-sm-6">
                      <div className="p-3 ">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          English Name
                        </label>
                        <input
                          {...register1("categoryen")}
                          defaultValue={
                            categoryById ? categoryById.categoryen : ""
                          }
                          type="text"
                          className="p-2  input_field_category_store"
                          required
                        />{" "}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 ">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Bangla Name
                        </label>
                        <input
                          {...register1("categorybn")}
                          defaultValue={
                            categoryById ? categoryById.categorybn : ""
                          }
                          type="text"
                          className="p-2  input_field_category_store"
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store  px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
